import { CARREGAR_LOTES_VENDA_SERVER, CARREGAR_LOTES_VENDA_STORE, ATUALIZAR_STATUS_VENDA_LOTE } from "../constants/constants";

export const carregarLotesServer = () =>({
    type : CARREGAR_LOTES_VENDA_SERVER
})

export const carregarLotesStore = (lotes) => ({
    type : CARREGAR_LOTES_VENDA_STORE,
    lotes
})

export const atualizarStatusLote = (id, status) =>({
    type : ATUALIZAR_STATUS_VENDA_LOTE,
    id,
    disponibilidade : status
})

window.carregarLotesServer = carregarLotesServer;
window.carregarLotesStore = carregarLotesStore;
window.atualizarStatusLote = atualizarStatusLote;


// WEBPACK FOOTER //
// ./src/actions/vendas.js